import { render, staticRenderFns } from "./EventListNonRetarded.vue?vue&type=template&id=0c984adc&scoped=true&"
import script from "./EventListNonRetarded.vue?vue&type=script&lang=js&"
export * from "./EventListNonRetarded.vue?vue&type=script&lang=js&"
import style0 from "./EventListNonRetarded.vue?vue&type=style&index=0&id=0c984adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c984adc",
  null
  
)

export default component.exports